module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-箭头.da506.png";